/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedStorytellingMainMedia_storyTellingTab = {
    readonly mainImage: string | null;
    readonly mainVideo: string | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedStorytellingShopAllLink_storyTellingTab">;
    readonly " $refType": "PdpSharedStorytellingMainMedia_storyTellingTab";
};
export type PdpSharedStorytellingMainMedia_storyTellingTab$data = PdpSharedStorytellingMainMedia_storyTellingTab;
export type PdpSharedStorytellingMainMedia_storyTellingTab$key = {
    readonly " $data"?: PdpSharedStorytellingMainMedia_storyTellingTab$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedStorytellingMainMedia_storyTellingTab">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedStorytellingMainMedia_storyTellingTab",
  "type": "StoryTellingTab",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "mainImage",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "mainVideo",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedStorytellingShopAllLink_storyTellingTab",
      "args": null
    }
  ]
};
(node as any).hash = 'a0bb043b6d8b5acc6369d686acce0c26';
export default node;
